import { Box, Divider, Text, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { RuleGroupList, RulesList, SectionDivider } from '@wix/rules-panel-ui';
import React from 'react';
import { BiCtaNames } from '../../bi/types';
import { usePanelStateAtom } from '../../hooks/rules-state';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { resolveGroupAnalysisState } from '../../utils/resolve-group-analysis-state';
import VerticalsDrillInMaxPagesWarning from '../../warnings/verticals-drill-in-max-pages-warning';
import { RuleResultsSkeleton } from '../wizard-content/rule-results-skeleton';
import { useVerticalDrillInScreen } from './use-vertical-drill-in-screen';
export const VerticalsDrillInContent = () => {
  var _getGroupData;
  const {
    t
  } = useTranslation();
  const {
    itemType,
    divRef,
    pageId,
    crossPagesRuleResult,
    specificRuleGroupPaginationObject,
    shouldShowMaxPagesWarning
  } = useVerticalDrillInScreen();
  const biLogger = useBiLogger();
  const {
    ruleGroupToShow,
    isPaginationEnabled,
    setIsPaginationEnabled,
    getPaginationComponent,
    isPagination
  } = specificRuleGroupPaginationObject;
  const {
    getGroupData
  } = usePanelStateAtom();
  const analysisState = (_getGroupData = getGroupData(pageId ?? '')) == null ? void 0 : _getGroupData.analysisState;
  const isAnalyzing = analysisState ? resolveGroupAnalysisState(analysisState).isAnalyzing : false;
  const shouldShowSkeleton = pageId && analysisState && isAnalyzing;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement("div", {
    ref: divRef
  }, /*#__PURE__*/React.createElement(SectionDivider, {
    title: t(`accessibility-wizard.verticals-drill-in.content-section.cross-pages-rules.divider`),
    tooltipContent: t(`accessibility-wizard.verticals-drill-in.content-section.cross-pages-rules.tooltip.${itemType}`),
    isBottomDivider: true
  }), shouldShowSkeleton ? /*#__PURE__*/React.createElement(RuleResultsSkeleton, {
    analysisState: analysisState,
    pageId: pageId
  }) : /*#__PURE__*/React.createElement(RulesList, {
    parentNodeRef: divRef,
    ruleResults: crossPagesRuleResult
  }), /*#__PURE__*/React.createElement(SectionDivider, {
    title: t('accessibility-wizard.verticals-drill-in.content-section.page-specific-rules.divider'),
    tooltipContent: t(`accessibility-wizard.verticals-drill-in.content-section.page-specific-rules.tooltip.${itemType}`),
    isTopDivider: true
  }), isPagination && isPaginationEnabled && getPaginationComponent(), ruleGroupToShow.length > 0 ? /*#__PURE__*/React.createElement(RuleGroupList, {
    parentNodeRef: divRef,
    ruleGroups: ruleGroupToShow
  }) : /*#__PURE__*/React.createElement(Divider, null), isPagination && isPaginationEnabled && !shouldShowMaxPagesWarning && getPaginationComponent(), !isPaginationEnabled && /*#__PURE__*/React.createElement(Box, {
    margin: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    secondary: true
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      text: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "thin",
        secondary: true
      }),
      textButton: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "tiny",
        skin: "dark",
        underline: "always",
        weight: "thin",
        onClick: () => {
          biLogger.ctaClick({
            ctaName: BiCtaNames.ShowAllPages
          });
          setIsPaginationEnabled(true);
        }
      })
    },
    i18nKey: t(`accessibility-wizard.verticals-drill-in.content-section.pagination.enable-pagination.${itemType}`)
  }))), shouldShowMaxPagesWarning && /*#__PURE__*/React.createElement(VerticalsDrillInMaxPagesWarning, {
    itemType: itemType
  }), ruleGroupToShow.length === 0 && /*#__PURE__*/React.createElement(Divider, null)));
};
//# sourceMappingURL=verticals-drill-in-content.js.map